import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";
import {
  constiBenchMediaAction,
  constiBenchTextDataAction,
} from "../actions/researchActions";

//------------------------------------------------------------------------------

export const getConstiBenchTextApi = function* getConstiBenchText(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield put(constiBenchTextDataAction(res?.data?.data));
      yield action.successCallBack(res);
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//------------------------------------------------------------------------------

export const getConstiBenchMediaApi = function* getConstiBenchMedia(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      const mediaData = Array.isArray(res?.data) ? res.data : res?.data?.data;
      yield put(constiBenchMediaAction(mediaData || []));
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//------------------------------------------------------------------------------

export const getJudgesTypeListApi = function* getJudgesTypeList(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//------------------------------------------------------------------------------

export const getJudgesTypeDetailtApi = function* getJudgesTypeDetail(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//------------------------------------------------------------------------------

export const getJudicialTimeTrackerTextApi =
  function* getJudicialTimeTrackerText(action) {
    yield put({ type: "SHOW_LOADER" });
    let path = action.path;
    try {
      const res = yield call(performGetRequest, path);
      if (res !== undefined && res.status === 200) {
        yield action.successCallBack(res);
      } else if (res.data.status === "error") {
        yield put({ type: "HIDE_LOADER" });
      }
    } catch (error) {
      yield put({ type: "HIDE_LOADER" });
    }
  };

//------------------------------------------------------------------------------

export const getTimeTrackerViaYearApi = function* getTimeTrackerViaYear(
  action
) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//------------------------------------------------------------------------------

export const getArchiveHeadingTextApi = function* getArchiveHeadingText(
  action
) {
  yield put({ type: "SHOW_LOADER" });
  let path = "/constitution_bench/archieve_text";
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};
//------------------------------------------------------------------------------
